import { Box, Typography } from '@mui/material';
import * as React from 'react';
import { FunctionComponent } from 'react';
import HomeConsumerDisplay from './HomeConsumerDisplay';
import PortableConsumerDisplay from './PortableConsumerDisplay';
import { LayoutStyles } from '../automotivePage/AutomotiveOverviewPage';
import { ApplicationsConsumerContent } from '../../graphql/pimcore/modules/siteContent/types/ApplicationsContent';
import { InternalLinkSection } from '../common/internalLinkSection';
import { GetResponsiveWidth } from '../common/TabsComponent';

interface ConsumerOverviewPageProps {
    cmsContent: ApplicationsConsumerContent;
}

const ConsumerOverviewPage: FunctionComponent<ConsumerOverviewPageProps> = ({ cmsContent }) => {
    const { temperatureSensorLinks } = cmsContent;
    const hasTemperatureSensorLinks = temperatureSensorLinks.links.length > 0;

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '0',
                    width: '100%',
                    boxSizing: 'border-box',
                    flexDirection: 'column',
                    overflowY: 'hidden',
                    backgroundColor: '#F2F2F2',
                }}
            >
                <Box sx={LayoutStyles}>
                    <Typography sx={{ fontFamily: 'Poppins', fontSize: '24px', fontWeight: 700 }}>
                        {cmsContent.overviewTitle.content}
                    </Typography>
                    <Typography
                        component="div"
                        sx={{
                            fontFamily: 'Poppins',
                            fontSize: '16px',
                            fontWeight: 400,
                            lineHeight: '24px',
                            marginTop: '1.5rem',
                            marginBottom: '2rem',
                        }}
                        dangerouslySetInnerHTML={{
                            __html: cmsContent.overviewMainText.content,
                        }}
                    ></Typography>
                </Box>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '0',
                    width: '100%',
                    boxSizing: 'border-box',
                    flexDirection: 'column',
                    overflowY: 'hidden',
                    backgroundColor: 'white',
                }}
            >
                <Box sx={{ ...LayoutStyles, marginBottom: '2rem' }}>
                    <HomeConsumerDisplay cmsContent={cmsContent} />
                </Box>
            </Box>
            <Box
                sx={{
                    display: 'flex',
                    justifyContent: 'center',
                    padding: '0',
                    width: '100%',
                    boxSizing: 'border-box',
                    flexDirection: 'column',
                    overflowY: 'hidden',
                    backgroundColor: '#F2F2F2',
                }}
            >
                <Box sx={{ ...LayoutStyles, marginBottom: '2rem', backgroundColor: '#F2F2F2' }}>
                    <PortableConsumerDisplay cmsContent={cmsContent} />
                </Box>
            </Box>
            {hasTemperatureSensorLinks ? (
                <InternalLinkSection
                    section={temperatureSensorLinks}
                    backgroundColor="white"
                    contentPadding={{
                        width: GetResponsiveWidth,
                        margin: 'auto',
                        alignItems: 'flex-start',
                    }}
                />
            ) : null}

            <Box sx={{ backgroundColor: 'white', height: '10px' }}></Box>
        </>
    );
};

export default ConsumerOverviewPage;
